import { render, staticRenderFns } from "./TenantDeclineDialog.vue?vue&type=template&id=725f26c6&"
import script from "./TenantDeclineDialog.vue?vue&type=script&lang=js&"
export * from "./TenantDeclineDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports